"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _EasyToolTip = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/EasyToolTip");

var _EasyToolTip2 = _interopRequireDefault(_EasyToolTip);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonWrap = (0, _glamor.css)(_fonts.btnWrap, {
  textAlign: "center"
}, (0, _css.maxWidth)(_css.breakpoints.small)({
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "2em",
  marginBottom: "2em"
}));

var buttonBase = function buttonBase(loading, disabled, small, smaller, smallest) {
  return (0, _glamor.css)((0, _fonts.btnBase)(loading, disabled, small, smaller, smallest), {
    position: "relative",
    display: "inline-block",
    cursor: loading || disabled ? "not-allowed" : "pointer",

    background: "none",

    border: "2px solid " + _css.colors.white,
    borderRadius: (0, _css.unitRem)(2),

    textDecoration: "none",
    textTransform: "uppercase",

    // eslint-disable-next-line no-nested-ternary
    padding: (smaller || smallest ? 1.125 : small ? 1.95 : 3) + "em",
    // eslint-disable-next-line no-nested-ternary
    paddingTop: (smaller || smallest ? 0.375 : small ? 0.75 : 1) + "em",
    // eslint-disable-next-line no-nested-ternary
    paddingBottom: (smaller || smallest ? 0.45 : small ? 0.85 : 1.05) + "em",

    color: _css.colors.white,

    transition: "transform " + _css.time.fast + ", box-shadow " + _css.time.fast,

    ":hover": {
      transform: !disabled && !loading && "translateY(-2px)",
      boxShadow: !disabled && !loading && "0 15px 50px rgba(0,0,0,0.35)"
    },

    ":active": {
      boxShadow: !disabled && !loading && "none",
      transform: !disabled && !loading && "translateY(0)",

      transition: !disabled && !loading && "none"
    },

    ":focus": {
      outline: "none"
    }
  }, (0, _css.minWidth)(_css.breakpoints.small)({
    // eslint-disable-next-line no-nested-ternary
    paddingTop: (smaller || smallest ? 0.4 : small ? 0.9 : 1.2) + "em",
    // eslint-disable-next-line no-nested-ternary
    paddingBottom: (smaller || smallest ? 0.4 : small ? 0.9 : 1.2) + "em"
  }));
};

var primaryCss = (0, _glamor.css)({
  backgroundColor: _css.pallets.green,
  backgroundImage: _css.gradients.green,

  border: "none"
});
var disabledCss = (0, _glamor.css)({
  backgroundColor: _css.pallets.gray_text,

  border: "none"
});

var secondaryCss = (0, _glamor.css)({
  backgroundColor: _css.pallets.blue_primary,
  //backgroundImage: gradients.blue,

  border: "none"
});

var tertiaryCss = (0, _glamor.css)({
  backgroundColor: _css.pallets.gray_text,
  backgroundImage: _css.gradients.gray,

  border: "none"
});

var yellowCss = (0, _glamor.css)({
  backgroundColor: _css.colors.yellow,
  backgroundImage: _css.gradients.yellow,
  border: "none"
});
var redCss = (0, _glamor.css)({
  backgroundColor: _css.pallets.red,
  backgroundImage: "linear-gradient(135deg, #E1615D, #E15141)",
  border: "none"
});
var grayBorder = (0, _glamor.css)({
  color: _css.pallets.gray_text,
  border: "1px " + _css.pallets.gray_text + " solid"
});

var whiteBorder = (0, _glamor.css)({
  color: _css.pallets.white,
  border: "2px " + _css.pallets.white + " solid"
});

var additional = _ramda2.default.cond([[_ramda2.default.equals("primary"), _ramda2.default.always(primaryCss)], [_ramda2.default.equals("disabled"), _ramda2.default.always(disabledCss)], [_ramda2.default.equals("secondary"), _ramda2.default.always(secondaryCss)], [_ramda2.default.equals("tertiary"), _ramda2.default.always(tertiaryCss)], [_ramda2.default.equals("yellow"), _ramda2.default.always(yellowCss)], [_ramda2.default.equals("red"), _ramda2.default.always(redCss)], [_ramda2.default.equals("transparentWithGrayBorder"), _ramda2.default.always(grayBorder)], [_ramda2.default.equals("transparentWithWhiteBorder"), _ramda2.default.always(whiteBorder)]]);

var styles = function styles(mode, loading, disabled, small, smaller, smallest) {
  return (0, _glamor.css)(buttonBase(loading, disabled, small, smaller, smallest), additional(disabled ? "disabled" : mode));
};

var preloader = function preloader(disabled, small, smaller, smallest) {
  return (0, _glamor.css)({
    position: "absolute",

    width: small || smaller || smallest ? 12 : 18,
    height: small || smaller || smallest ? 12 : 18,

    // eslint-disable-next-line no-nested-ternary
    top: (smaller || smallest ? 6 : small ? 13 : 14) + "px",
    right: (0, _css.unitRem)(0.45),

    borderColor: _css.colors.white,
    borderLeftColor: "transparent !important",
    borderWidth: smaller || smallest ? 1 : small ? 2 : 3
  }, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
    top: (smaller || smallest ? 10 : small ? 17 : 17) + "px",
    right: "1rem"
  }));
};

var _tooltip = (0, _glamor.css)({});

var isValidButtonMode = _ramda2.default.flip(_ramda2.default.contains)(["primary", "secondary", "tertiary", "yellow", "normal", "red", "transparentWithGrayBorder", "transparentWithWhiteBorder"]);

var Button = function Button(_ref) {
  var className = _ref.className,
      label = _ref.label,
      to = _ref.to,
      href = _ref.href,
      loading = _ref.loading,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      mode = _ref.mode,
      small = _ref.small,
      smaller = _ref.smaller,
      newHome = _ref.newHome,
      smallest = _ref.smallest,
      toolTip = _ref.toolTip,
      restProps = (0, _objectWithoutProperties3.default)(_ref, ["className", "label", "to", "href", "loading", "onClick", "disabled", "mode", "small", "smaller", "newHome", "smallest", "toolTip"]);
  return _react2.default.createElement(
    "span",
    { className: (0, _glamor.css)(buttonWrap, className) },
    (to || href) && _react2.default.createElement(
      "span",
      null,
      toolTip && _react2.default.createElement(
        _EasyToolTip2.default,
        { position: "top", message: toolTip },
        _react2.default.createElement(
          _reactRouter.Link,
          (0, _extends3.default)({
            className: styles(mode, loading, disabled, small, smaller, smallest),
            to: to,
            href: href,
            onClick: onClick
          }, restProps),
          toolTip && _react2.default.createElement(_EasyToolTip2.default, { position: "top", message: "Hi", toolTip: toolTip }),
          label,
          loading && _react2.default.createElement(_Preloader2.default, {
            className: preloader(false, small, smaller, smallest)
          })
        )
      ),
      !toolTip && _react2.default.createElement(
        _reactRouter.Link,
        (0, _extends3.default)({
          className: styles(mode, loading, disabled, small, smaller, smallest),
          to: to,
          href: href,
          onClick: onClick
        }, restProps),
        toolTip && _react2.default.createElement(_EasyToolTip2.default, { position: "top", message: "Hi", toolTip: toolTip }),
        label,
        loading && _react2.default.createElement(_Preloader2.default, {
          className: preloader(false, small, smaller, smallest)
        })
      )
    ),
    !to && !href && _react2.default.createElement(
      "span",
      null,
      toolTip && _react2.default.createElement(
        _EasyToolTip2.default,
        { className: _tooltip, position: "top", message: toolTip },
        _react2.default.createElement(
          "button",
          (0, _extends3.default)({
            style: { whiteSpace: "nowrap" },
            className: styles(mode, loading, disabled, small, smaller, smallest),
            onClick: onClick,
            disabled: disabled || loading
          }, restProps),
          label,
          loading && _react2.default.createElement(_Preloader2.default, {
            className: preloader(disabled, small, smaller, smallest)
          })
        ),
        " "
      ),
      !toolTip && _react2.default.createElement(
        "button",
        (0, _extends3.default)({
          style: { whiteSpace: "nowrap" },
          className: styles(mode, loading, disabled, small, smaller, smallest),
          onClick: onClick,
          disabled: disabled || loading
        }, restProps),
        label,
        loading && _react2.default.createElement(_Preloader2.default, {
          className: preloader(disabled, small, smaller, smallest)
        })
      )
    )
  );
};

Button.defaultProps = { mode: "normal" };

exports.default = Button;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Button.jsx
// module id = 2866
// module chunks = 0